import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-two',
  templateUrl: './about-two.component.html',
  styleUrls: ['./about-two.component.scss']
})
export class AboutTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
